import { forwardRef } from "react";
import { Link as RouterLink, type LinkProps as RouterLinkProps } from "react-router-dom";

/**
 * @deprecated Use the TextButton component from cbh-mobile-app's redesign system to show links instead.
 * ui-components has been removed from cbh-core.
 * Link redirection logic should be handled by the specific application that consumes this component.
 */
export const BaseLink = forwardRef<HTMLAnchorElement, RouterLinkProps>((props, ref) => {
  return <RouterLink ref={ref} {...props} />;
});

BaseLink.displayName = "BaseLink";
